import React, { useState,useEffect } from "react";
import { equifaxDataError } from "./data";
import { Done } from "@mui/icons-material";

const Exquifaxv2ReportModal = ({
  isOpen,
  onClose,
  Equifaxv2Report,
  Equifaxv2Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
}) => {
useEffect(() => {

}, [Equifaxv2Report],[equifaxDataError]);

  const [isPrinting, setIsPrinting] = useState(false);

  if (!isOpen) return null; // Do not render anything if not open

  const printDiv = () => {
    setIsPrinting(true);

    // Create a temporary window for printing 
    const printWindow = window.open("", "", "height=600,width=800");
    const printContents = document.getElementById("invoicedata").innerHTML;

    // Write the content to the new window
    printWindow.document.write("<html><head><title>Print</title>");
    printWindow.document.write(
      '<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">'
    );
    printWindow.document.write("</head><body >");
    printWindow.document.write(printContents);
    printWindow.document.write("</body></html>");

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();

      setIsPrinting(false);
    }, 100);
  };



const getPaymentStatusBgColor = (status) => {
  if (status === '000' || status === 'STD') return 'bg-green-100 text-green-800';
  if (status === 'XXX') return 'bg-gray-100 text-gray-600';
  if (status === '030') return 'bg-yellow-100 text-yellow-800';
  if (status === '060') return 'bg-orange-100 text-orange-800';
  if (status === '090') return 'bg-red-100 text-red-800';
  if (status === 'SUB' || status === 'DBT' || status === 'LSS') return 'bg-red-200 text-red-900';
  return 'bg-white text-gray-800';
};

const getPaymentStatusText = (status) => {
  const statusMap = {
    '000': 'Payment on time',
    'STD': 'Standard - Paid within 90 days',
    '030': '30 days past due',
    '060': '60 days past due',
    '090': '90 days past due',
    'XXX': 'No payment data reported',
    'SUB': 'Substandard',
    'DBT': 'Doubtful',
    'LSS': 'Loss'
  };
  return statusMap[status] || status;
};



  const modalData = Equifaxv2Report && Equifaxv2Report;
  const modalDataError = Equifaxv2Error && Equifaxv2Error;


  const glossaryData = [
    { code: '000', description: 'current account' },
    { code: 'CLSD', description: 'Paid or closed account/zero balance' },
    { code: 'NEW', description: 'New Account' },
    { code: 'LNSB', description: 'Loan Submitted' },
    { code: 'LAND', description: 'Loan Approved - Not yet disbursed' },
    { code: 'INAC', description: 'Account is Inactive' },
    { code: 'CON', description: 'Contact Member for Status' },
    { code: '01+', description: '1-29 days past due' },
    { code: '30+', description: '30-59 days past due' },
    { code: 'DEC', description: 'Loan Declined' },
    { code: '60+', description: '60-89 days past due' },
    { code: 'SPM', description: 'Special Mention' },
    { code: 'SUB', description: 'Sub-standard' },
    { code: 'RES', description: 'Restructured Loan' },
    { code: 'RGM', description: 'Restructured Loan - Govt Mandate' },
    { code: 'RNC', description: 'Restructured Loan - Natural Calamity' },
    { code: 'SET', description: 'Settled' },
    { code: 'SF', description: 'Suit Filed' },
    { code: '90+', description: '90-119 days past due' },
    { code: '120+', description: '120-179 days past due' },
    { code: '180+', description: '180-359 days past due' },
    { code: '360+', description: '360-539 days past due' },
    { code: '540+', description: '540-719 days past due' },
    { code: '720+', description: '720 or more days past due' },
    { code: 'DBT', description: 'Doubtful' },
    { code: 'FPD', description: 'First Payment Default' },
    { code: 'WDF', description: 'Willful Default' },
    { code: 'PWO', description: 'Part Written Off Settled' },
    { code: 'WOF', description: 'Charge Off/Written Off' },
    { code: 'Non-Delinq', description: 'Non Delinquent' },
    { code: 'Delinq', description: 'Delinquent' },
    { code: 'RCV', description: 'Restructured Due to COVID19' },
    { code: 'PWOS', description: 'Post Write Off Settled' }
  ];


// Helper to format labels
const formatLabel = (key) => {
  return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim();
};

// Helper for styling
const getFieldStyle = (key, value) => {
  if (key === 'PastDueAmount') {
    return value > 0 ? 'text-red-700 font-bold' : 'text-green-600 font-semibold';
  }
  if (key === 'AccountStatus') {
    return value === 'Active' || value === 'Current Account' ? 'text-green-600 font-bold' : 'text-red-600 font-bold';
  }
  if (key === 'Balance' || key === 'SanctionAmount') return 'text-green-600 font-bold';
  if (key === 'Institution') return 'text-blue-600 font-semibold';
  return 'text-gray-600 font-semibold';
};



  return (
    <div className="fixed inset-0 flex  flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-4">
      <div
        className="bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]"
        id="invoicedata"
      >
        <div className="a4-page">
  <div className="grid grid-cols-12 items-center">
  {/* Logo - Always at start */}
  <div className="col-span-3 flex justify-start">
              <img
                src="https://imgs.search.brave.com/6iV5QNxEpERp5OAG16hROi1fGXw0TI7pe8Po1HzXnjI/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9kMXB0/NncybXQyeHFzby5j/bG91ZGZyb250Lm5l/dC9BY3VDdXN0b20v/U2l0ZW5hbWUvREFN/LzAxOS9FcXVpZmF4/LUxvZ28uanBn"
                className="w-64"
                alt="Company Logo"
              />
            </div>
              <div className="col-span-6 ml-5 flex justify-between items-center ">
              {/* <h4 className="text-xl font-bold">Credit Report</h4> */}
              <h4 className="text-xl font-semibold text-gray-400 ml-6">MFI BASIC CREDIT REPORT V1.0</h4>
            </div>
          <div className="col-span-3 flex justify-end text-sm">
              Credit Score:{" "}
              <strong className="text-xl ml-1 -mt-[6px]">
                {
                  modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData
                    ?.ScoreDetails[0]?.Value
                }
              </strong>
            </div>
          </div>

          <div className="flex justify-between items-start flex-wrap text-xs px-4 mb-2">
            {/* Start section */}
            <div className="">
              <p>
                <i className="font-semibold">Client ID:</i>{" "}
                <span className="client_id">
                  {modalData?.InquiryResponseHeader?.ClientID}
                </span>
              </p>
              <p>
                <i className="font-semibold">Report Order No:</i>{" "}
                <span className="report_order_no">
                  {modalData?.InquiryResponseHeader?.ReportOrderNO}
                </span>
              </p>
            </div>

            {/* End section */}
            <div className="">
              <p>
                <i className="font-semibold">Date:</i>{" "}
                <span className="report_date">
                  {modalData?.InquiryResponseHeader?.Date}
                </span>
              </p>
              <p>
                <i className="font-semibold">Time:</i>{" "}
                <span className="report_time">
                  {modalData?.InquiryResponseHeader?.Time}
                </span>
              </p>
            </div>
          </div>
        
{displayMessageBlock && (() => {
  const message =
    Equifaxv2Error?.error?.credit_report_message?.message ||
    Equifaxv2Error?.message ||
    Equifaxv2Report?.message ||
    reportMessage ||
    "";

  const code =
    Equifaxv2Error?.error?.credit_report_message?.message_code ||
    Equifaxv2Error?.message_code ||
    Equifaxv2Report?.message_code ||
    reportCode ||
    "";

  const isSuccess = message?.toLowerCase().includes("success");

  // 🛑 Don't show anything if it's success
  if (isSuccess) return null;

  const formatText = (text) =>
    text?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <>{(message?.length > 0 || code?.length > 0) && (
  <div className="flex flex-col items-center justify-center my-5">
    <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
      <p className="text-center text-black font-bold">
        Error: <span className="font-normal">{formatText(message)}</span>
      </p>
      <p className="text-center text-black font-bold mt-1">
        Code: <span className="font-normal">{formatText(code)}</span>
      </p>
    </div>
  </div>
)}
</>
  );
})()}

<hr color="black" className="px-2 bg-black"/>

                      {/* Consumer Name */}
              <div className="px-3">
                <p>
                  <i className="font-semibold">Consumer Name</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.InquiryRequestInfo?.FirstName ||
                      modalDataError?.data?.name ||
                      modalDataError?.name ||
                     modalDataError?.error?.name ||
                      "N/A"}
                  </span>
                </p>
              </div>


          <div className="flex justify-start bg-red-900 text-white mt-2">
            <p className="font-semibold  text-xs text-start px-2">Personal Details</p>
          </div>

          <div className="border p-2 rounded-md px-4">
            <div className="grid gap-1 text-xs">
              {/* Consumer Name */}
              <div>
                <p>
                  <i className="font-semibold">Alias Name</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.InquiryRequestInfo?.FirstName ||
                      modalDataError?.data?.name ||
                      modalDataError?.name ||
                     modalDataError?.error?.name ||
                      "N/A"}
                  </span>
                </p>
              </div>

              <div>
                <p>
                  <i className="font-semibold">DOB</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.CCRResponse?.CIRReportDataLst?.[0]
                      ?.InquiryRequestInfo?.DOB || 
                      "N/A"}
                  </span>
                </p>
              </div>

              <div>
                <p>
                  <i className="font-semibold">Age</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.CCRResponse?.CIRReportDataLst?.[0]
                      ?.CIRReportData?.IDAndContactInfo?.PersonalInfo?.Age
                      ?.Age || "N/A"}
                  </span>
                </p>
              </div>

              <div>
                <p>
                  <i className="font-semibold">Gender</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.CCRResponse?.CIRReportDataLst?.[0]
                      ?.CIRReportData?.IDAndContactInfo?.PersonalInfo?.Gender ||
                      modalDataError?.data?.gender ||
                      modalDataError?.gender ||
                        modalDataError?.error?.gender ||
                      "N/A"}
                  </span>
                </p>
              </div>

              <div>
                <p>
                  <i className="font-semibold">Mob</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.CCRResponse?.CIRReportDataLst?.[0]
                      ?.InquiryRequestInfo?.InquiryPhones?.[0]?.Number ||
                      modalDataError?.data?.mobile ||
                      modalDataError?.mobile ||
                      modalDataError?.error.mobile ||
                      "N/A"}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <hr className="my-2" />
          <div className="md:text-black text-black p-1 mt-2 text-sm">
          Consumer Address
          </div>
          <table className="min-w-full table-auto border text-left text-[10px]">
            <thead className="bg-red-900 text-white">
              <tr>
                <th className="border px-1 py-0">Type</th>
                <th className="border px-1 py-0">Address</th>
                <th className="border px-1 py-0">State</th>
                <th className="border px-1 py-0">Postal</th>
                <th className="border px-2 py-0">ReportedDate</th>
              </tr>
            </thead>
            <tbody className="address-info">
              {Array.isArray(modalData?.CCRResponse?.CIRReportDataLst) &&
              modalData.CCRResponse.CIRReportDataLst.length > 0 ? (
                modalData.CCRResponse.CIRReportDataLst[0]?.CIRReportData?.IDAndContactInfo?.AddressInfo?.map(
                  (address, index) => (
                    <tr key={address.Seq}>
                      <td className="border px-1 py-0 font-bold">
                        {address.Type}
                      </td>
                      <td className="border px-1 py-0">
                        {address.Address}
                      </td>
                        <td className="border px-1 py-0">
                        {address.State}
                      </td>
                        <td className="border px-1 py-0">
                        {address.Postal}
                      </td>
                        <td className="border px-1 py-0">
                        {address.ReportedDate}
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td
                    colSpan="2"
                    className="border border-black px-1 py-0 text-center"
                  >
                    No address information available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Credit Score Section */}
          <div className="md:text-black p-1 text-black mt-2 text-sm">
            Equifax Score
          </div>
          <table className="min-w-full table-auto border text-left text-xs">
            <thead className="bg-red-900 text-white">
              <tr className="text-left">
                <th className="border px-1 py-0">Score Name</th>
              
                <th className="border px-1 py-0">
                  Scoring Elements
                </th>
                  <th className="border px-1 py-0">Score</th>
              </tr>
            </thead>
            <tbody className="scoreDetailsInfo">
              {Array.isArray(modalData?.CCRResponse?.CIRReportDataLst) &&
              modalData.CCRResponse.CIRReportDataLst.length > 0 &&
              Array.isArray(
                modalData.CCRResponse.CIRReportDataLst[0]?.CIRReportData
                  ?.ScoreDetails
              ) ? (
                modalData.CCRResponse.CIRReportDataLst[0].CIRReportData.ScoreDetails.map(
                  (scoreDetail, index) => (
                    <tr key={index} className="">
                      <td className="border px-2 py-1">
                        {scoreDetail.Name}
                      </td>
              

                      <td className="border  px-2 py-1">
                        <ul>
                          {Array.isArray(scoreDetail.ScoringElements) ? (
                            scoreDetail.ScoringElements.map((element, idx) => (
                              <li key={idx}>
                                <p>{element.Description}</p>
                              </li>
                            ))
                          ) : (
                            <li>No scoring elements available.</li>
                          )}
                        </ul>
                      </td>
                           <td className="border  px-1">
      <div className="flex flex-col items-center justify-center bg-green-300 rounded-lg border-green-700 border p-1 w-16 h-12">
        <span className="text-2xl font-bold text-blue-900">
           {scoreDetail.Value || "N/A"}
        </span>
        <span className="text-xs font-semibold text-blue-900">Score</span>
      </div>
    </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    className="border px-2 py-1 text-center"
                  >
                    No score details available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>







<table className="min-w-full table-auto text-left mt-2 border-collapse">
  <tbody className="mb-2 text-xs">
    {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountDetails?.map((account, index) => (
      <React.Fragment key={index}>
        
        {/* Header */}
        <tr className="bg-red-900 text-white">
          <td colSpan={6} className="px-2 py-1 border">
            RETAIL : <span className="font-bold text-yellow-300">{account.AccountType}</span>
          </td>
        </tr>

        {/* All Fields - Simple Loop */}
        <tr className="border">
          <td colSpan={6} className="px-2 py-1 border">
            <div className="grid grid-cols-3 gap-2">
              {Object.entries(account)
                .filter(([key]) => key !== 'History48Months')
                .map(([key, value]) => (
                  <div key={key}>
                    <span className="font-semibold text-black">{formatLabel(key)}:</span>{" "}
                    <span className={getFieldStyle(key, value)}>
                      {key === 'InterestRate' && value ? `${value}%` : value || 'N/A'}
                    </span>
                  </div>
                ))}
            </div>
          </td>
        </tr>

        {/* Payment History */}
        {account.History48Months?.length > 0 && (
          <tr>
            <td colSpan={6} className="px-1 py-0 border">
              <div className="flex justify-between items-center mb-2">
                <h2 className="font-semibold text-xs">Payment History</h2>
                <span className="text-[9px] text-gray-500">(Last 24 months)</span>
              </div>
              
              <div className="overflow-x-auto">
                <table className="text-[10px] border-collapse">
                  <thead>
                    <tr>
                      {account.History48Months.slice(0, 24).map((history, idx) => (
                        <th key={idx} className="border px-0.5 py-1 bg-gray-50 text-center w-[35px]">
                          {history.key}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {account.History48Months.slice(0, 24).map((history, idx) => (
                        <td 
                          key={idx}
                          className={`border px-0.5 py-1 text-center font-semibold ${getPaymentStatusBgColor(history.PaymentStatus)}`}
                        >
                          {history.PaymentStatus}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      {account.History48Months.slice(0, 24).map((history, idx) => (
                        <td key={idx} className="border px-0.5 py-1 text-center text-[8px]">
                          {history.AssetClassificationStatus}
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div className="mt-2 flex gap-2 text-[10px]">
                <span className="flex items-center gap-1">
                  <span className="w-3 h-3 bg-green-100 border"></span>000-OnTime
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-3 h-3 bg-yellow-100 border"></span>Late
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-3 h-3 bg-red-100 border"></span>Default
                </span>
              </div>
            </td>
          </tr>
        )}
      </React.Fragment>
    ))}
  </tbody>
</table>





{/* Render All Summary Sections Dynamically */}
{Object.entries(modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData || {})
  .filter(([key, value]) => key.includes('Summary') && typeof value === 'object')
  .map(([sectionKey, sectionData]) => (
    <div key={sectionKey} className="mb-4">
      
      {/* Dynamic Heading */}
      <div className="bg-red-900 text-white p-2 rounded-tl-md rounded-tr-md text-sm font-semibold">
        {sectionKey.replace(/([A-Z])/g, ' $1').trim()}
      </div>

      {/* Dynamic Fields */}
      <div className="border border-t-0 p-4">
        <div className="grid grid-cols-3 gap-3 text-xs">
          {Object.entries(sectionData).map(([fieldKey, fieldValue]) => (
            <div key={fieldKey}>
              <span className="font-semibold text-black">
                {fieldKey.replace(/([A-Z])/g, ' $1').trim()}:
              </span>{" "}
              <span className="text-gray-700 font-medium">{fieldValue || 'N/A'}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  ))}




 <div className=" md:text-black text-black p-1 mt-2 rounded-tl-md rounded-tr-md text-sm font-semibold">
           Enquiries
          </div>


<div className="w-full overflow-x-auto px-3">
  <table className="min-w-full border border-gray-300 text-xs">
    <thead className="bg-red-900 text-white sticky top-0 z-10">
      <tr>
        <th className="border px-1 py-0 text-left whitespace-nowrap">Seq</th>
        <th className="border px-1 py-0 text-left whitespace-nowrap">Institution</th>
        <th className="border px-1 py-0 text-left whitespace-nowrap">Date</th>
        <th className="border px-1 py-0 text-left whitespace-nowrap">Time</th>
        <th className="border px-1 py-0 text-left whitespace-nowrap">Purpose</th>
        <th className="border px-1 py-0 text-left whitespace-nowrap">Amount</th>
      </tr>
    </thead>

    <tbody>
      {modalData?.CCRResponse?.CIRReportDataLst?.[0]?.CIRReportData?.Enquiries?.map(
        (item, index) => (
          <tr key={index} className="hover:bg-gray-50 text-[10px]">
            <td className="border px-1 py-0 whitespace-nowrap">{item.seq}</td>
            <td className="border px-1 py-0 whitespace-nowrap">{item.Institution}</td>
            <td className="border px-1 py-0 whitespace-nowrap">{item.Date}</td>
            <td className="border px-1 py-0 whitespace-nowrap">{item.Time}</td>
            <td className="border px-1 py-0 whitespace-nowrap">{item.RequestPurpose}</td>
            <td className="border px-1 py-0 whitespace-nowrap">
              {item.Amount ? item.Amount : "-"}
            </td>
          </tr>
        )
      )}
    </tbody>
  </table>
</div>

    <div className="w-full max-w-4xl mx-auto p-1 sm:p-1 mt-2">
      <div className="bg-white shadow-md rounded-lg overflow-hidden px-3">
        {/* Header */}
        <div className="bg-gray-100 px-2 py-1 border-b border-gray-300">
          <h2 className="text-xs sm:text-sm font-semibold text-gray-800 mb-2">
            Glossary, Terms and Explanations:
          </h2>
        </div>

        {/* Table Container */}
        <div className="overflow-x-auto mt-2">

          <div className="md:text-black text-black text-sm">
            <u>
              History
            </u>
          </div>
          <table className="w-fit border-collapse text-[10px]">
            <thead>
              <tr className="bg-[#8B1A1A] text-white">
                {/* <th className="px-2 py-1 text-left font-semibold border-r border-white w-20 sm:w-24">
                  History
                </th> */}
                <th className="px-2 py-1 text-left font-semibold border-r border-white w-16 sm:w-20">
                  Code
                </th>
                <th className="px-2 py-1 text-left font-semibold">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {glossaryData.map((item, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                  } hover:bg-blue-50 transition-colors border-b border-gray-200`}
                >
                  {/* <td className="px-2 py-0.5 border-r border-gray-200">
                    Empty for History column
                  </td> */}
                  <td className="px-2 py-0.5 font-semibold text-gray-800 border-r border-gray-200">
                    {item.code}
                  </td>
                  <td className="px-2 py-0.5 text-gray-700">
                    {item.description}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>


   

 {/* Recent Activity Section */}
<div className="text-black md:text-black p-1 mt-2 text-xs font-semibold">
  Recent Activity (Last 90 Days)
</div>

<table className="min-w-full table-auto border text-left text-[10px]">
  <thead className="bg-red-900 text-white">
    <tr>
      <th className="border px-2 py-1">Total Inquiries</th>
      <th className="border px-2 py-1">Accounts Opened</th>
      <th className="border px-2 py-1">Accounts Updated</th>
      <th className="border px-2 py-1">Accounts Delinquent</th>
    </tr>
  </thead>
  <tbody>
    <tr className="border text-center bg-gray-50 hover:bg-gray-100">
      <td className="border px-2 py-1 text-blue-600 font-semibold">
        {
          modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData
            ?.RecentActivities.TotalInquiries
        }
      </td>
      <td className="border px-2 py-1 text-green-600 font-bold">
        {
          modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData
            ?.RecentActivities.AccountsOpened
        }
      </td>
      <td className="border px-2 py-1 text-yellow-600 font-semibold">
        {
          modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData
            ?.RecentActivities.AccountsUpdated
        }
      </td>
      <td className="border px-2 py-1 text-red-600 font-bold">
        {
          modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData
            ?.RecentActivities.AccountsDeliquent
        }
      </td>
    </tr>
  </tbody>
</table>

        </div>
    

{/* Summary Section */}
<div className=" text-black md:text-black p-1 mt-2 text-xs font-semibold">
  Summary
</div>

{/* Table 1 – Basic Account Info */}
<table className="min-w-full table-auto border text-[10px] mb-2">
  <thead className="bg-red-900 text-white">
    <tr>
      <th className="border px-2 py-1">Number of Accounts</th>
      <th className="border px-2 py-1">Active Accounts</th>
      <th className="border px-2 py-1">Write-Offs</th>
      <th className="border px-2 py-1">Past Due Accounts</th>
      <th className="border px-2 py-1">Zero Balance Accounts</th>
      <th className="border px-2 py-1">Recent Account</th>
      <th className="border px-2 py-1">Oldest Account</th>
    </tr>
  </thead>
  <tbody>
    <tr className="bg-white hover:bg-gray-100">
      <td className="border px-2 py-1 text-blue-600 font-semibold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.NoOfAccounts}
      </td>
      <td className="border px-2 py-1 text-green-600 font-semibold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.NoOfActiveAccounts}
      </td>
      <td className="border px-2 py-1 text-red-600 font-semibold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.NoOfWriteOffs}
      </td>
      <td className="border px-2 py-1 text-yellow-600 font-semibold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.NoOfPastDueAccounts}
      </td>
      <td className="border px-2 py-1 text-indigo-600 font-semibold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.NoOfZeroBalanceAccounts}
      </td>
      <td className="border px-2 py-1 text-gray-700 font-semibold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.RecentAccount}
      </td>
      <td className="border px-2 py-1 text-gray-900 font-semibold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.OldestAccount}
      </td>
    </tr>
  </tbody>
</table>



{/* Table 2 – Balance & Payment Info */}
<table className="min-w-full table-auto border text-[10px] mb-2">
  <thead className="bg-red-900 text-white">
    <tr>
      <th className="border px-2 py-1">Total Balance</th>
      <th className="border px-2 py-1">Total Past Due</th>
      <th className="border px-2 py-1">Average Open Balance</th>
      <th className="border px-2 py-1">Single Highest Balance</th>
      <th className="border px-2 py-1">Total Monthly Payment</th>
    </tr>
  </thead>
  <tbody>
    <tr className="bg-white hover:bg-gray-100">
      <td className="border px-2 py-1 text-green-600 font-bold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.TotalBalanceAmount}
      </td>
      <td className="border px-2 py-1 text-red-600 font-bold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.TotalPastDue}
      </td>
      <td className="border px-2 py-1 text-blue-600 font-semibold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.AverageOpenBalance}
      </td>
      <td className="border px-2 py-1 text-yellow-600 font-semibold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.SingleHighestBalance}
      </td>
      <td className="border px-2 py-1 text-indigo-600 font-semibold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.TotalMonthlyPaymentAmount}
      </td>
    </tr>
  </tbody>
</table>  

{/* Table 3 – Credit & Sanction Info */}
<table className="min-w-full table-auto border text-[10px] mb-2">
  <thead className="bg-red-900 text-white">
    <tr>
      <th className="border px-2 py-1">Single Highest Credit</th>
      <th className="border px-2 py-1">Total High Credit</th>
      <th className="border px-2 py-1">Total Sanction Amount</th>
      <th className="border px-2 py-1">Single Highest Sanction</th>
      <th className="border px-2 py-1">Total Credit Limit</th>
      <th className="border px-2 py-1">Most Severe Status (24M)</th>
    </tr>
  </thead>
  <tbody>
    <tr className="bg-white hover:bg-gray-100">
      <td className="border px-2 py-1 text-blue-600 font-semibold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.SingleHighestCredit}
      </td>
      <td className="border px-2 py-1 text-purple-600 font-semibold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.TotalHighCredit}
      </td>
      <td className="border px-2 py-1 text-green-600 font-bold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.TotalSanctionAmount}
      </td>
      <td className="border px-2 py-1 text-yellow-600 font-semibold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.SingleHighestSanctionAmount}
      </td>
      <td className="border px-2 py-1 text-indigo-600 font-semibold">
        ₹{modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.TotalCreditLimit}
      </td>
      <td className="border px-2 py-1 text-red-600 font-bold">
        {modalData?.CCRResponse?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary?.MostSevereStatusWithIn24Months}
      </td>
    </tr>
  </tbody>
</table>



          <div className='mt-2'>
  <h3 className="text-green-800 text-center font-bold">Report END
     <span>
                    {" "}
                    :{" "}
                    {modalData?.InquiryRequestInfo?.FirstName ||
                      modalDataError?.data?.name ||
                      modalDataError?.name ||
                     modalDataError?.error?.name ||
                      "N/A"}
                  </span>
  </h3>
</div>
      </div>
      <div className="flex justify-center mt-2">
        <button
          className="bg-green-500 text-white p-2 rounded hover:bg-green-700"
          onClick={printDiv}
          disabled={isPrinting}
        >
          Print
        </button>
        <button
          className="bg-red-500 text-white p-2 rounded hover:bg-red-700"
          onClick={onClose} // This should close the modal
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Exquifaxv2ReportModal;





